import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    alignToLogo: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Align to logo (New)"
    },
    maxWidth: {
      type: FIELD_TYPES.TEXT,
      label: "Max width (px)"
    },
    tabWidth: {
      type: FIELD_TYPES.TEXT,
      label: "Tab width (px)"
    },
    contentMarginTop: {
      type: FIELD_TYPES.TEXT,
      label: "Content margin top (px)"
    },
    tabContentMaxWidth: {
      type: FIELD_TYPES.TEXT,
      label: "Tab content max width"
    },
    iconSize: {
      type: FIELD_TYPES.TEXT,
      label: "Icon size (px)"
    },
    ...SharedAdvancedFieldsConfig
  }
};
